import React from "react";
import { Input, Button } from "arv-reactcomponents";
import { Search } from "arv-extends";

const { wrapper, getFinalComponent } = Search.default;

class WcSearch extends wrapper {
  componentDidUpdate() {
    if (this.props.SearchBarStore.showSearch) {
      console.log("search active");
      const searchInput = document.querySelector(".wc-search-input");
      if (searchInput) {
        searchInput.focus();
      }
      const { queryApplied } = this.props.ProductStore;
      if (queryApplied && !this.queryUpdatedFromStore) {
        this.queryUpdatedFromStore = true;
        this.updateSearchText(queryApplied);
      }
    }
  }
  render() {
    return (
      <div className={`wc-search ${this.isSearchOpenClassName}`}>
        <form
          onSubmit={this.handleSubmit}
          autoComplete="off"
          id="wc-search-form"
          className="wc-search-form"
        >
          <Input
            id="search"
            type="text"
            className="nwc-inp-xxl wc-search-input"
            placeholder="Enter Search..."
            value={this.state.searchText}
            onChange={this.handleChange}
          />
          <Button className="nwc-btn-primary-txt wc-search-enter">
            <i className="icomoon-search3" />
          </Button>
        </form>
        <Button className="wc-search-overlay" onClick={this.toggleSearch}>
          <div />
        </Button>
      </div>
    );
  }
}

Search.default.component = getFinalComponent(WcSearch);
